(function () {
  function normalize(str) {
    return (str || '').toString().trim().toLowerCase();
  }

  function updateComboFilter(options) {
    var colorVal = normalize(options.option1);
    var styleVal = normalize(options.option2);

    var comboEls = document.querySelectorAll('.product-main-slide, .product__thumb-item');
    var firstVisibleMainIndex = null;

    comboEls.forEach(function (el) {
      var isUniversal = el.hasAttribute('data-combo-universal');
      var comboColor = el.getAttribute('data-combo-color');
      var comboStyle = el.getAttribute('data-combo-style');

      var visible;
      if (isUniversal) {
        visible = true;
      } else if (comboColor !== null) {
        visible = colorVal.indexOf(comboColor) !== -1 && styleVal.indexOf(comboStyle) !== -1;
      } else {
        visible = true;
      }

      el.classList.toggle('combo-hidden', !visible);

      if (visible && el.classList.contains('product-main-slide') && firstVisibleMainIndex === null) {
        var idx = parseInt(el.getAttribute('data-index'), 10);
        if (!isNaN(idx)) {
          firstVisibleMainIndex = idx;
        }
      }
    });

    var sliderEl = document.querySelector('[data-product-photos]');
    if (sliderEl && window.Flickity) {
      var flkty = window.Flickity.data(sliderEl);
      if (flkty) {
        flkty.reloadCells();
        flkty.resize();
        if (firstVisibleMainIndex !== null) {
          flkty.select(firstVisibleMainIndex, false, true);
        }
      }
    }
  }

  window.ComboImageFilter = { update: updateComboFilter };

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      updateComboFilter({
        option1: event.detail.variant.option1,
        option2: event.detail.variant.option2
      });
    }
  });
})();